import React from "react";
import { TopBar } from "@/components/Nav";
import QuizRunner from "@/components/QuizRunner";
import SortRunner from "@/components/SortRunner";
import { findObjectItems, sortMatchRounds } from "@/lib/quizgen";

export function FindObjectGame() {
  return (
    <>
      <TopBar title="Find the Object" backTo="/play" />
      <QuizRunner title="Find the Object" category="games" modeId="find-object" build={findObjectItems} backTo="/play" />
    </>
  );
}

export function SortMatchGame() {
  return (
    <>
      <TopBar title="Sort & Match" backTo="/play" />
      <SortRunner title="Sort & Match" category="games" modeId="sort-match" build={sortMatchRounds} backTo="/play" />
    </>
  );
}
